import { Component, Input, OnInit, Renderer2, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';

import { FormComponent, originalOrder } from '../form/form.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ContentService } from 'src/app/base/services/content/content.service';
import { LoginNavService } from 'src/app/base/services/login-nav/login-nav.service';
import { AppComponent } from 'src/app/app.component';
import { AppidService } from 'src/app/base/services/appid/appid.service';
import { NavService } from 'src/app/base/services/nav/nav.service';
import { environment } from 'src/environments/environment';


@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent extends FormComponent implements OnInit {

    @Input() submitMessage: string;

    appID: number;
    appLogo;
    orgLogo: string | null = null;

    selectedRole = 0;
    loginInProgress = false;
    links: any = null;
    topNavs: any = null;
    originalOrder: any;
    parentNavID;

    constructor(
        route: ActivatedRoute,
        dialog: MatDialog,
        contentService: ContentService,
        // Dependencies of this component
        private snackBar: MatSnackBar,
        private router: Router,
        private loginNavService: LoginNavService,
        public http: HttpClient,
        public app: AppComponent,
        public appIDService: AppidService,
        private nav: NavService,

        // gets style sheet values. Core Angular nomenclature.
        private renderer: Renderer2,
        @Inject(DOCUMENT) private document: Document
    ) { 
        super(route, dialog, contentService);
    }

    ngOnInit() {
        super.ngOnInit();

        this.appIDService.appID$.subscribe(id => {
            this.appID = id;
            this.appLogo = this.appIDService.appLogo;
            this.loadLoginTheme(id);
        });

        this.loginNavService.topNavData$.subscribe((data) => {
            this.topNavs = data;

            // Select the nav item that matches the current route            
            const currentRoot = this.router.url.split('/')[1]; 
            
            // Find the nav item that matches the current route and has hasPage = false, bc the topnav doen't have a main page.
            const topNavParent = data.find(nav => 
                nav.path?.split('/')[0] === currentRoot && 
                nav.data.hasPage === false
            );
            
            // Save the nav ID of the parent item to highlight it in the UI.
            this.parentNavID = topNavParent ? +topNavParent.data.nav : null;
			
        });
        
        this.loginNavService.sideNavData$.subscribe((data) => {
            data = data.filter(link => link.label !== 'Login');
            this.links = data;
        });

        this.originalOrder = originalOrder;

        // If an org_id is in the URL, load the org's logo.
		// Same code as header-base.component.ts for GIG.
        const orgID = this.route.snapshot.queryParams['org_id'];
        if (orgID) {
            this.nav.getOrgLogo(orgID).subscribe((data: any) => {
                if (data) {
                    this.orgLogo = `${environment.urls.core}/files/886/${data}`;
                }
            });
        }
    }

    private loadLoginTheme(appID: number): void {

        // Remove the previously loaded login theme, if any (e.g. on app switch).
        const existing = this.document.querySelector('link[data-login-theme]');
        if (existing) {
            this.renderer.removeChild(this.document.head, existing);
        }

        // Create a new <link> tag pointing to this app's login theme stylesheet.
        // File is expected at: src/assets/login/{appID}/login.css
        const link = this.renderer.createElement('link') as HTMLLinkElement;
        this.renderer.setAttribute(link, 'rel', 'stylesheet');
        this.renderer.setProperty(link, 'href', `assets/login/${appID}/login.css`);

        // Mark the link so we can find and remove it next time
        this.renderer.setAttribute(link, 'data-login-theme', String(appID));

        this.renderer.appendChild(this.document.head, link);
    }

	// Generically called getQueryParams in case it is used for more than org_id in the future.
    getQueryParams(): Params {

		const orgId = this.route.snapshot.queryParamMap.get('org_id') ?? localStorage.getItem('org');
		return orgId ? { org_id: orgId } : {};
	}

    /**
     * Takes the message, action, and duration and opens a snackbar with the given parameters.
     * 
     * @param message 
     * @param action 
     * @param duration 
     * 
     * @returns void
     */
    openSnackBar(message: string, action: string, duration: number) {

        //if the screen is wider than 768px, use the default snackbar
        if (window.innerWidth > 768) {
            this.snackBar.open(message, action, {
                duration,
            });
        } else {

            this.snackBar.open(message, action, {
                duration,
                verticalPosition: 'bottom',
                panelClass: 'mat-snack-bar-container-panel-class'
            });
        }
    }
   
}